<script setup lang="ts">
import EmptyStateIconUrl from '@Shared/components/visuals/visualAssets/EmptyState_Icon.svg?url';

defineProps<{
  hasNoData?: boolean;
  isFrontline?: boolean;
  title?: string;
}>();
</script>
<template>
  <div class="relative ml-2 h-full flex flex-col bg-white mr-2 flex">
    <div class="flex flex-row justify-between">
      <div v-if="title" class="text-4 color-[#4F4F4F] font-semibold font-family[Poppins] xs:text-5 xl:text-4">
        {{ title }}
      </div>
      <div v-else class="inline-block loading-gradient h-50% w-33% rounded-2"></div>
    </div>
    <div
      v-if="hasNoData && !isFrontline"
      class="absolute top-45% left-0 text-center w-full text-[#828282] text-sm xl:text-3 2xl:text-4.5 3xl:text-9 3xl:line-height-3rem font-bold"
    >
      There are no new responses. <br />Please check again later.
    </div>
    <div
      v-if="hasNoData && isFrontline"
      class="absolute left-0 text-center w-full text-[#828282] xl:text-3 font-family[Roboto] xl:line-height-1rem top-40% xs:text-4 xs:line-height-1.5rem"
    >
      <img :src="EmptyStateIconUrl" alt="" />
      <div class="xl:max-w-[200px] m-auto xs:max-w-[240px]">
        <span>
          Nothing to see here. You can try changing the
          <strong>filter</strong> to see some data.
        </span>
      </div>
    </div>
    <div class="h-75% mt-auto mb-auto">
      <div
        class="h-full w-full lined-grid flex items-center"
        style="border: solid #f9f9f9 2px; border-top: 0; border-left: 0"
      >
        <svg
          height="100%"
          class="line-gradient"
          viewBox="0 0 826 60"
          fill="none"
          width="100%"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.61426 57.849C2.61426 57.849 69.6844 17.0406 121.679 15.761C171.178 14.5428 190.892 50.2033 240.384 48.8338C291.011 47.4329 305.479 11.101 355.903 7.61492C403.613 4.31644 423.527 39.5006 471.444 38.4559C518.977 37.4195 543.761 6.02862 591.104 2.86305C636.517 -0.173449 661.762 9.02052 707.24 11.688C752.744 14.3569 823.999 16.5206 823.999 16.5206"
            stroke="url('#line-gradient')"
            stroke-width="6"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>
<style scoped>
.lined-grid {
  background-size: 25% 50%;
  background-image:
    linear-gradient(to right, #f9f9f9 2px, transparent 2px), linear-gradient(to bottom, #f9f9f9 2px, transparent 2px);
}
</style>
